import { useState, useEffect } from 'react';
import automatizacioncontrol from '../assets/automatizacioncontrol.jpg';
import controleselectricos from '../assets/controleselectricos.jpg';
import materialeselectricos from '../assets/materialeselectricos.jpg';
import neumatica from '../assets/neumatica.jpg';
import perfilesposter from '../assets/perfilesposter.png';
import teflonesposter from '../assets/teflonesposter.png';
import tornillosinoxidablesposter from '../assets/tornillosinoxidablesposter.png';
import herramientasposter from '../assets/herramientasposter.jpg';
import loclineposter from '../assets/LOCLINEposter.png';
import estanteriasposter from '../assets/estanteriaposter.png';


//Departametos iconos
import iconautomatizacion from '../assets/automatizacion.jpg';
import iconcontroles from '../assets/controles.jpg';
import iconmelectricos from '../assets/melectricos.jpg';
import iconneumatica from '../assets/neumaicaico.jpg';
import iconperfiles from '../assets/paluminio.jpg';
import iconteflones from '../assets/teflonesico.jpg';
import icontornillosinoxidables from '../assets/tonillosInoxidables.jpg';
import iconherramientas from '../assets/herramientasico.jpg';
import iconlocline from '../assets/tonillosInoxidables.jpg';
import iconestanterias from '../assets/paluminio.jpg';


const departments = [
  {
    title: "Neumática",
    description: "Suministro de componentes y sistemas neumáticos industriales de alta eficiencia, incluyendo cilindros, válvulas, conexiones y unidades de tratamiento de aire.",
     icon: <img src={iconneumatica} alt="Neumática" className="w-16 h-16 object-contain" />,
    image: neumatica // Imagen para Neumática
  },
  {
    title: "Automatización y Controles",
    description: "Soluciones integrales en automatización industrial, sensores, PLC, HMI, variadores de frecuencia y sistemas de control de procesos para optimizar tu producción.",
    icon: <img src={iconautomatizacion} alt="Automatizacion" className="w-16 h-16 object-contain" />,
    image: automatizacioncontrol // Imagen para Automatización y Controles
  },
  {
    title: "Teflones",
    description: "Venta y fabricación de piezas en teflón (PTFE) y otros polímeros de alto rendimiento, ideales para aplicaciones industriales que requieren baja fricción y resistencia química.",
    icon: <img src={iconteflones} alt="Teflones" className="w-16 h-16 object-contain" />,
    image: teflonesposter // Imagen para Teflones
  },
  {
    title: "Perfiles de Aluminio",
    description: "Perfilería modular de aluminio para la construcción de estructuras industriales, estaciones de trabajo, transportadores, cerramientos de seguridad y sistemas de montaje personalizados.",
    icon: <img src={iconperfiles} alt="Perfiles de Aluminio" className="w-16 h-16 object-contain" />,
    image: perfilesposter // Imagen para Perfiles de Aluminio
  },
  {
    title: "Tornillos Inoxidables",
    description: "Amplia gama de tornillería en acero inoxidable de alta calidad (A2, A4) para diversas aplicaciones industriales, garantizando resistencia a la corrosión y durabilidad.",
    icon: <img src={icontornillosinoxidables} alt="Tornillos Inoxidables" className="w-16 h-16 object-contain" />,
    image: tornillosinoxidablesposter // Imagen para Tornillos Inoxidables
  },
  {
    title: "Materiales Eléctricos",
    description: "Distribución de materiales eléctricos esenciales para instalaciones industriales, incluyendo cables, contactores, interruptores, protecciones, canalizaciones y accesorios.",
    icon: <img src={iconmelectricos} alt="Materiales Eléctricos" className="w-16 h-16 object-contain" />,
    image: materialeselectricos // Imagen para Materiales Eléctricos
  },
  {
    title: 'Herramientas',
    description: 'Amplia variedad de herramientas manuales y eléctricas para mantenimiento, montaje y trabajos industriales de precisión.',
    image: herramientasposter, // Imagen para Herramientas
    icon: <img src={iconherramientas} alt="Herramientas" className="w-16 h-16 object-contain" />
  },
  {
    title: 'Loc-Line',
    description: 'Sistemas modulares de mangueras y accesorios Loc-Line ideales para refrigeración, aspiración de humos y direccionamiento de fluidos en procesos industriales.',
    image: loclineposter, // Imagen para Loc-Line
    icon: <img src={iconlocline} alt="Loc-Line" className="w-16 h-16 object-contain" />
  },
  {
    title: 'Estanterías Metálicas y Rampas Industriales',
    description: 'Soluciones resistentes y versátiles para almacenamiento y logística, incluyendo estanterías metálicas de alta capacidad y rampas industriales seguras para carga y descarga.',
    image: estanteriasposter, // Imagen para Estanterías
    icon: <img src={iconestanterias} alt="Estanterías" className="w-16 h-16 object-contain" />
  }
];

const ServicesPage = ({ setCurrentPage, setDepartmentName }) => {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          element.classList.add('opacity-100', 'translate-y-0', 'scale-100');
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleExploreClick = (deptTitle) => {
    setDepartmentName(deptTitle);
    setCurrentPage('department');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-gray-900 mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
          Nuestros <span className="text-red-600">Servicios y Departamentos</span>
        </h1>

        <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-100">
          En R&M Componentes Industriales, ofrecemos una amplia gama de productos y soluciones especializadas para cada necesidad de tu industria, respaldadas por la más alta calidad y soporte técnico.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {departments.map((dept, index) => (
            <div 
              key={index} 
              className={`bg-gray-50 p-10 rounded-xl shadow-xl transform hover:scale-105 transition-all duration-500 delay-${index * 100} animate-on-scroll opacity-0 translate-y-10`}
            >
              <div className="h-48 overflow-hidden rounded-lg mb-6">
                <img 
                  src={dept.image} 
                  alt={dept.title} 
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
              </div>
              <div className="flex justify-center mb-6">
                {dept.icon}
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">{dept.title}</h2>
              <p className="text-gray-700 leading-relaxed text-center">{dept.description}</p>
              <button 
                onClick={() => handleExploreClick(dept.title)}
                className="mt-8 text-red-600 font-medium hover:text-red-800 transition-colors flex items-center justify-center mx-auto group"
              >
                Explorar 
                <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </div>
          ))}
        </div>

        {/* Sección de servicios adicionales (si aplica) 
        <div className="mt-20 text-center animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-800">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Servicios de <span className="text-red-600">Valor Agregado</span></h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Además de nuestra amplia gama de productos, ofrecemos asesoría técnica especializada, diseño de sistemas a medida y un sólido soporte post-venta para garantizar el éxito y la continuidad operativa de tus proyectos.
          </p>
          <button className="mt-10 bg-gray-800 hover:bg-gray-900 text-white font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg">
            Conoce nuestros servicios de soporte
          </button>
        </div>
        */}
      </div>
    </div>
  );
};
export default ServicesPage;